import React from 'react';
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import TNCMenu from '@cont/CompanyDetails/TNCMenu';
import { sanitize as sanitizeHtml } from 'isomorphic-dompurify';

const LeftContainer = styled.div`
  grid-column: 1/6;
  position: sticky;
  top: ${Spacings.SPACING_HEADER}px;
  height: fit-content;

  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const RightContainer = styled.div`
  grid-column: 6/25;

  ${mediaQuery.uptoTablet} {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    color: var(--color-text-primary);
  }
  p {
    font-size: ${Fonts.SMALL};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: var(--color-text-primary);
  }
  a {
    color: var(--color-i-blue);
    p {
      color: var(--color-i-blue);
    }
  }
  h1 {
    font-size: ${Fonts.H2};
    line-height: ${Fonts.PARA_LINE_HEIGHT};
    margin: 0 0 ${Spacings.SPACING_4B};
  }
  h2,
  h3,
  strong {
    font-size: ${Fonts.H5};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_2B};
  }
  h2 {
    font-size: ${Fonts.H2};
  }
  h3 {
    font-size: ${Fonts.H3};
  }
  h5 {
    font-size: ${Fonts.H5};
  }
  h6 {
    font-size: ${Fonts.H6};
    font-weight: 600;
  }
  ul,
  ol {
    color: var(--color-text-primary);
    li {
      margin-bottom: 4px;
      line-height: 150%;
      font-size: 14px;
      color: var(--color-text-primary);
    }
    table {
      text-align: left;
      border-radius: ${Spacings.SPACING_2B};
      border-collapse: collapse;
      margin: 32px 0;
      ${mediaQuery.uptoMobile} {
        margin: 24px 0;
      }
      ul {
        color: var(--color-text-primary);
        li {
          margin-bottom: 4px;
        }
      }
      tr {
        th,
        td {
          border: ${Spacings.SPACING_1} solid var(--color-divider);
          padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
          font-size: ${Fonts.SMALL};
          line-height: ${Fonts.HEADER_LINE_HEIGHT};
          font-weight: 600;
        }
        td {
          font-weight: 400;
        }
        th {
          white-space: nowrap;
        }
        ul {
          margin: 0;
          list-style: none;
          li {
            &::before {
              content: '•';
              color: var(--color-text-primary);
              display: inline-block;
              width: 1em;
              margin-left: -1em;
              line-height: 120%;
            }
            margin-bottom: 0;
          }
        }
      }
    }
    .number-list {
      ol {
        list-style-type: none;
        counter-reset: item;
        margin: 0;
        padding: 0;
      }
      li {
        display: table;
        counter-increment: item;
        margin-bottom: 0.6em;
      }
      li:before {
        content: counters(item, '.') '. ';
        display: table-cell;
        padding-right: 0.6em;
      }
      li li {
        margin: 0;
      }
      li li:before {
        content: counters(item, '.') ' ';
      }
    }
    section {
      padding-top: ${Spacings.SPACING_8B};
      h2 {
        margin-top: 0;
      }
    }
  }
`;

const TermsDetail = ({ isSidebar, content, menuData }) => {
  const updatedContent = content.replace(/<h2>(.*?)<\/h2>/i, '<h1>$1</h1>');
  return isSidebar ? (
    <>
      <LeftContainer>
        <TNCMenu menuData={menuData} />
      </LeftContainer>
      <RightContainer>
        <TermsWrapper
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(updatedContent, { allowedAttributes: false })
          }}
        />
      </RightContainer>
    </>
  ) : (
    <TermsWrapper
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(updatedContent, { allowedAttributes: false })
      }}
    />
  );
};

export default TermsDetail;
